import React from "react";

import ChatSkeleton from "../chat/ChatSkeleton";
import CardHeaderLabel from "./CardHeaderLabel";

const AdminChatDockCard = () => {
  return (
    <div className="flex h-full min-h-0 flex-col text-white">
      <CardHeaderLabel label="Chat" className="text-white" />
      <ChatSkeleton />
    </div>
  );
};

export default AdminChatDockCard;
